var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(!_vm.user.phone_verified)?_c('phone-number-snackbar'):(_vm.user.documents_state !== 2)?_c('documents-snackbar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }